import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { UserDataService } from './user-data.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileImageService {
  profileImage: string | null = null;
  imageUrl: string | null = this.userData.getUser()?.settings?.image_url ?? null;


  constructor(private http: HttpClient, private userData: UserDataService) {
    this.refreshProfileImage();
  }

  downloadAndStoreImage(imageUrl: string) {
    this.http.get(imageUrl, { responseType: 'blob', withCredentials: false }).subscribe({
      next: (blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Image = reader.result as string;
          localStorage.setItem('profileImage', base64Image);
          localStorage.setItem('profileImageUrl', imageUrl);
          this.profileImage = base64Image;
        };
        reader.readAsDataURL(blob);
      },
      error: () => {
        this.profileImage = imageUrl;
      }
    });
  }

  refreshProfileImage() {
    this.imageUrl = this.userData.getUser()?.settings?.image_url ?? null;

    const storedImage = localStorage.getItem('profileImage');
    const storedImageUrl = localStorage.getItem('profileImageUrl');

    if (storedImage && storedImageUrl === this.imageUrl) {
      this.profileImage = storedImage;
    } else if (this.imageUrl) {
      this.downloadAndStoreImage(this.imageUrl);
    }
  }

  resetProfileImage() {
    this.imageUrl = this.userData.getUser()?.settings?.image_url ?? null;

    localStorage.removeItem('profileImage');
    localStorage.removeItem('profileImageUrl');
    if (this.imageUrl) {
      this.downloadAndStoreImage(this.imageUrl);
    }
    else {
      this.profileImage = null;
    }
  }

  getProfileImage(): string | null {
    return this.profileImage;
  }
}
